import type { Brand } from './brands';

const themeCss = import.meta.glob<string>('../css/app.*.less', {
  query: '?url',
  eager: true,
  import: 'default',
});

function cssHref(theme: string): string | undefined {
  return themeCss[`../css/app.${theme}.less`] || themeCss['../css/app.grid.less'];
}

function applyBrandStylesheet(brand: Brand): void {
  // The build bakes this link into each brand's entry HTML, so it is only missing in dev.
  if (document.querySelector('link[data-brand-css]')) {
    return;
  }
  const href = cssHref(brand.theme);
  if (!href) {
    return;
  }
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.setAttribute('data-brand-css', 'true');
  link.href = href;
  document.head.appendChild(link);
}

function applyBrandMetadata(brand: Brand): void {
  if (!brand.metadataHtml || document.querySelector('[data-brand-metadata]')) {
    return;
  }
  const marker = document.createElement('meta');
  marker.setAttribute('data-brand-metadata', 'true');
  document.head.appendChild(marker);

  const wrap = document.createElement('div');
  wrap.innerHTML = brand.metadataHtml;
  while (wrap.firstChild) {
    document.head.appendChild(wrap.firstChild);
  }
}

export function applyBrandTheme(brand: Brand): void {
  applyBrandStylesheet(brand);
  applyBrandMetadata(brand);
}
